import { FilterSectionLayout } from "@web-src/modules/filters/components/FilterSectionLayout";
import { FilterPill } from "@web-src/modules/filters/components/FilterPill";
import { Checkbox } from "@jugl-web/ui-components";
import { useFilters } from "../../hooks/useFilters";

interface TypeCheckboxFilterProps {
  title: string;
  options: {
    label: string;
    value: string;
  }[];
  filters: ReturnType<typeof useFilters>;
}

export const TypeCheckboxFilter = ({
  title,
  options,
  filters,
}: TypeCheckboxFilterProps) => {
  const { isOptionSelected, toggleFilterOption } = filters;

  return (
    <FilterSectionLayout>
      <FilterSectionLayout.Header title={title} />
      {options.length > 0 && (
        <FilterSectionLayout.PillsContainer>
          {options.map((option) => {
            const isChecked = isOptionSelected(title, option.value);

            return (
              <FilterPill
                key={option.value}
                startIcon={
                  <Checkbox
                    className="h-[15px] w-[15px]"
                    readOnly
                    tabIndex={-1}
                    isChecked={isChecked}
                  />
                }
                label={option.label}
                onClick={() => toggleFilterOption(title, option.value)}
              />
            );
          })}
        </FilterSectionLayout.PillsContainer>
      )}
    </FilterSectionLayout>
  );
};
